// extracted by mini-css-extract-plugin
module.exports = {"content":"ProfileContent_content__0Z2dK"};